<template>
    <div class="phone-container">
        <div class="phone phone-notch"></div>
        <div class="phone phone-background-image" :style="{ backgroundImage : jsonCode.BackgroundPictureEncodedPNGString.length > 4 ? `url('${jsonCode.BackgroundPictureEncodedPNGString}')` : `url('src/assets/background-example.png')` }"></div>
        <div v-if="jsonCode.CompanyLogoEncodedPNGString.length < 4" class="phone phone-logo phone-logo-placeholder">Your logo here</div>
        <div v-else class="phone phone-logo phone-logo-custom" :style="{ backgroundImage : `url('${jsonCode.CompanyLogoEncodedPNGString}')` }"></div>
        <div class="phone phone-qr-code"></div>
        <div class="phone phone-background-color" :style="{ backgroundColor : jsonCode.BackColor }"></div>
        <p class="phone phone-representative phone-representative-name" :style="{ color : jsonCode.FontColor }">Lorem Ipsum</p>
        <p class="phone phone-representative phone-representative-title" :style="{ color : jsonCode.FontColor }">CEO</p>
    </div>
</template>

<script>


  export default {
    props: {
      jsonCode: Object
    },
    methods: {
      setPhoneNotchAspectRatio(ratio) {
        const notch = this.$el.querySelector('.phone-notch')
        notch.style.aspectRatio = ratio
      }
    },
    created() {
      const component = this

      let svg = new Image()
      svg.src = 'src/assets/phone-notch.svg'
      svg.onload = function() {
        component.setPhoneNotchAspectRatio(svg.width/svg.height)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/PhoneView/PhoneViewDisplay.vue